import React from 'react'
import { CircularProgress, Button } from '@material-ui/core'
import styles from './LoadingButton.module.css'

const noop = () => {}

const LoadingButton = ({
  onClick = noop,
  className = '',
  label = 'Aceptar',
  color = 'primary',
  disabled = false,
  isLoading = false,
  startIcon = <></>,
  size = undefined,
  variant = 'contained'
}) => {
  if (isLoading)
    return <CircularProgress size={30} className={styles.progress} />
  else
    return (
      <Button
        className={className}
        onClick={onClick}
        variant={variant}
        color={color}
        disabled={disabled}
        startIcon={startIcon ?? null}
        size={size}
      >
        {label}
      </Button>
    )
}

export default LoadingButton
